<template>
    <FormCard>
        <template #cardTitle>
            Consultation Details
        </template>
        <template #cardSubtitle>
            Please clarify the context of your visit and your main consultation reason.
        </template>
        <template #cardText>
            <v-radio-group
                v-model="medico_legal"
                column
                :rules="[v=> v !== null || 'This question is required']"
            >
                <template #label>
                    <div style="font-family: sans-serif; font-size: 16px; color: black">
                        Are you having consultation because of vehicular accident or other medico-legal case?
                    </div>
                </template>
                <v-radio
                    color="teal darken-1"
                    label="Yes"
                    :value="true"
                />
                <v-radio
                    color="teal darken-1"
                    label="No"
                    :value="false"
                />
            </v-radio-group>
            <v-text-field
                v-model="reason"
                clearable
                label="Reason for Consultation:"
                :rules="rules.reasonRules"
                color="teal"
                autocomplete="nope"
            />
        </template>
    </FormCard>
</template>

<script>
import FormCard from '../Other/FormCard.vue'
export default {
    components: { FormCard },
    data: ()=>({
        rules: {
            reasonRules: [
                v => !!v || 'This field is required!',
                v => v && v.trim().length > 0 || 'This field is required!',
                v => /[a-zA-Z]/.test(v) || 'Please provide a valid reason!'
            ]
        },
        medico_legal: null,
        reason: null
    }),
    watch: {
        medico_legal(newVal) {
            this.$emit('saveMedicoLegal', newVal)
        },
        reason(newVal) {
            this.$emit('saveReason', newVal)
        }
    }
}
</script>
